import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../common/constants';
import utils from '../../../common/utils';

export default class ContentMgtTocService extends BaseService {
  constructor() {
    super(constants.GET_CHATGPT_TOC_DATA, 'ChatGptUtilityTocStatus');
  }

  handleEvent(eventName, event) {
    const { payload, headers } = utils.buildRequestPartsFromPayload(event);
    this.isAetQuiz = payload?.aetquiz;
    this.isAetTopic = payload?.aettopic;

    // Remove aetquiz and aettopic flags from payload before sending to API
    const { aetquiz, aettopic, ...apiPayload } = payload;

    if (this.isAetQuiz) {
      return this.getClient('aiadminv2').post(`/cm/quiz-aet`, apiPayload, { headers });
    }
    if (this.isAetTopic) {
      return this.getClient('aiadminv2').post(`/cm/topic-aet`, apiPayload, { headers });
    }
    return this.getClient('aiadmin').post(`/chatutility/quizmcq/getquestion`, apiPayload, { headers });
  }

  handleResponse(response) {
    const { data } = response;
    const dataArray = data.data;
    let storeToUse = 'chatgptTocUtility';

    if (this.isAetQuiz) {
      storeToUse = 'aetQuizUtility';
    } else if (this.isAetTopic) {
      storeToUse = 'aetTopicUtility';
    }

    if (data.status === 'success' && dataArray.length > 0) {
      Framework.getStoreRegistry().getStore(storeToUse).setResponse(response.data);
    } else {
      const notification = {
        open: true,
        type: 'error',
        message: 'Data Not Found'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
      Framework.getStoreRegistry().getStore(storeToUse).resetStoreValues();
    }
  }

  handleError(error) {
    // eslint-disable-line class-methods-use-this
    const { response } = error;
    let storeToUse = 'chatgptTocUtility';

    if (this.isAetQuiz) {
      storeToUse = 'aetQuizUtility';
    } else if (this.isAetTopic) {
      storeToUse = 'aetTopicUtility';
    }

    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      if (status === 500 && data && data.error) {
        const notification = {
          open: true,
          message: data.error.message,
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      }
    } else if (error.message === 'timeout of 60000ms exceeded') {
      const notification = {
        open: true,
        message: error.message,
        type: 'error'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    }
    Framework.getStoreRegistry().getStore(storeToUse).resetStoreValues();
  }
}
